import { makeAutoObservable } from "mobx";
import { translations } from "../locales/Locales";

class LanguageStore {
    language = localStorage.getItem('currentLang') || 'ru';

    constructor() {
        makeAutoObservable(this);
    }

    setLanguage(lang) {
        this.language = lang;
    }

    t = (key, ...args) => {
        const dict = translations[this.language] || {};
        const value = dict[key];

        if (typeof value === "function") {
            return value(...args);
        }

        return value || key;
    }
}

const languageStore = new LanguageStore();
export default languageStore;